// extracted by mini-css-extract-plugin
export default {"overlay":"overlay-panel_overlay__YrOFr","left":"overlay-panel_left__0JIke","right":"overlay-panel_right__x1g19"};